import React from "react";
import {View, Text, TouchableOpacity, StyleSheet} from "react-native";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import FastImage from "../../../common/FastImage";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {check, gridIcons_Cross, promo_offer, tick} from "../../../utils/images";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";

const CouponBlk = ({
  isOnDepositScreen = false,
  onViewMoreClick,
  isCouponResponse,
  couponItem,
  onApplyclick,
  onCouponRemove,
}) => {
  const coupon = couponItem?.couponcode;

  const couponStatusMap = {
    failed: {
      iconOffer: gridIcons_Cross,
      title: isCouponResponse?.coupon + " not applied",
      isBtnShow: "Remove",
      subtitle: isCouponResponse?.msg,
    },
    success: {
      iconOffer: tick,
      title: isCouponResponse?.applied_msg,
      isBtnShow: true,
      btnText: "Remove",
      subtitle: null,
    },
    normal: {
      title: coupon,
      isBtnShow: true,
      btnText: "Apply",
      subtitle: couponItem?.offer,
      iconOffer: promo_offer,
    },
  };
  const couponMappedObj = couponStatusMap[isCouponResponse?.status || "normal"];

  return (
    <View style={styles.containerBlk}>
      <View style={styles.containerInternalFirstHalf}>
        <View style={{flex: 1}}>
          <View style={{flexDirection: "row", alignItems: "center"}}>
            {isOnDepositScreen && couponMappedObj?.iconOffer ? (
              <FastImage
                style={{width: 18, height: 18, marginRight: 5}}
                source={couponMappedObj?.iconOffer()}
              />
            ) : null}
            <Text style={globalFontStyle.appFontSubHeading}>
              {couponMappedObj?.title}
            </Text>
          </View>

          {couponMappedObj?.subtitle && (<View style={{flexDirection: "row", marginTop: 4, flex: 1}}>
            {couponMappedObj?.icon ? (
              <FastImage
                style={{width: 15, height: 15}}
                source={couponMappedObj?.icon()}
              />
            ) : null}
            <Text
              style={[
                globalFontStyle.appFontSubText,
                !isOnDepositScreen
                  ? {color: Colors.green}
                  : {color: Colors.grey2, flex: 1},
              ]}>
              {couponMappedObj?.subtitle}
            </Text>
          </View>)}
        </View>
        {couponMappedObj?.isBtnShow ? (
          couponMappedObj?.btnText === "Apply" ? (
            <TouchableOpacity
              onPress={() => {
                onApplyclick(couponItem?.couponcode);
              }}
              style={styles.applyBtnStyle}>
              <FormTextLabel
                labelStyles={[globalFontStyle.appFontSubText]}
                label={"Apply"}
              />
            </TouchableOpacity>
          ) : (
            <TouchableOpacity onPress={onCouponRemove}>
              <FormTextLabel
                labelStyles={[
                  globalFontStyle.appFontSubText,
                  {color: Colors.blue1},
                ]}
                label={"Remove"}
              />
            </TouchableOpacity>
          )
        ) : null}
      </View>
      <View style={{borderTopWidth: 0.75,
        borderTopColor: Colors.borderColor,
        borderStyle: 'dashed',
        marginBottom: 10,
      }}/>
      <TouchableOpacity
        activeOpacity={0.7}
        style={{paddingHorizontal: 12}}
        onPress={() => {
          isOnDepositScreen && onViewMoreClick();
        }}>
        {isOnDepositScreen ? (
            <View style={{
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: 'row'
            }}>
              <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontSubText,
                    {color: GlobalScreens.Wallet.highlightColor},
                  ]}
                  label={"View more coupons"}
              />
              <FastImage
                  style={{width: 25, height: 25}}
                  source={globalConfigurableData.right_arrow_black()}
              />
            </View>
        ) : (
          <Text
            style={[globalFontStyle.appFontSmallText, {color: Colors.black2}]}>
            {couponItem?.description}
          </Text>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default CouponBlk;

const styles = StyleSheet.create({
  containerBlk: {
    borderRadius: 8,
    borderWidth: 0.75,
    borderColor: "rgba(0, 0, 0, 0.30)",
    paddingVertical: 14,
    flex: 1,
    backgroundColor: '#FAFAFA'
  },
  containerInternalFirstHalf: {
    flexDirection: "row",
    justifyContent: "space-between",
    //borderBottomStyle: 'dotted',
    //borderBottomWidth: 1,
    //borderBottomRadius: 1,
    paddingHorizontal: 12,
    paddingBottom: 12,
    flex: 1,
  },
  applyBtnStyle: {
    height: 30,
    borderWidth: 0.75,
    // paddingVertical: 7,
    paddingHorizontal: 12,
    borderRadius: 8,
    justifyContent: "center"
  },
});
